// Mock data for BASE Construction (frontend-only clone of Artico layout)
// Content pulled from base-support.co.uk per client request.

const IMG = "https://framerusercontent.com/images";

export const services = [
  {
    id: "conversions",
    title: "Conversions",
    body:
      "Barn, loft and garage conversions that transform underused spaces into characterful, functional living areas across Devon and Cornwall.",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/gwyr3knu_conversions.webp",
    cta: "Get in Touch",
    ctaLink: "/contact",
    large: true,
  },
  {
    id: "extensions",
    title: "Extensions",
    tagline: "More space, seamlessly.",
    body:
      "Thoughtfully designed extensions that expand and elevate your home while blending effortlessly with the existing build.",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/x86q30gy_Extensions.webp",
  },
  {
    id: "new-builds",
    title: "New Builds",
    tagline: "Built from the ground up.",
    body:
      "Ground-up, one-off homes delivered from foundation to finish — managed in-house through every stage.",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/qm0n3nvu_New%20builds.webp",
  },
  {
    id: "refurbishments",
    title: "Refurbishments",
    tagline: "Refined to the last detail.",
    body:
      "High-end renovations and refurbishments delivering premium finishes, joinery and lighting throughout.",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/j3xtmscc_refurbishments.jpg",
  },
  {
    id: "commercial",
    title: "Commercial & Retail",
    tagline: "Brand-led spaces, built right.",
    body:
      "High-end commercial and retail spaces delivered to specification, on programme and to an exacting standard.",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/f85db1ad4a1af096_Commerical%20%3A%20Retail%20.jpeg",
  },
  {
    id: "education",
    title: "Education & Schools",
    tagline: "Built for learning.",
    body:
      "Classrooms, extensions and refurbishments for schools and education settings — delivered safely, to programme and with minimal disruption to term time.",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/898d3b44d0777a0d_school-a.jpg",
  },
];

export const process = [
  {
    num: "01",
    title: "Consultation",
    body: "We understand your vision, your drawings and your timescales.",
  },
  {
    num: "02",
    title: "Tender & Programme",
    body:
      "A detailed cost plan and programme of works — broken down so you can make informed decisions.",
  },
  {
    num: "03",
    title: "Build",
    body:
      "Our team on site, every day. Dedicated project manager, weekly reporting, and zero surprises.",
  },
  {
    num: "04",
    title: "Handover",
    body:
      "A snag-free, on-time completion. We don't leave until the space is exactly what was promised.",
  },
];

export const completedProjects = [
  {
    id: "top-of-the-creek",
    name: "Top of the Creek",
    location: "Kingsbridge",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/b8qqau4t_Top%20of%20the%20Creek%20-%20Kingsbridge.webp",
  },
  {
    id: "the-fairway",
    name: "The Fairway",
    location: "Newton Ferrers",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/vion0u9d_The%20Fairway%20-%20Newton%20Ferrers.png",
  },
  {
    id: "nest-cottage",
    name: "Nest Cottage",
    location: "Noss Mayo",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/6ox80s24_Nest%20Cottage%20-%20Noss%20Mayo.webp",
  },
  {
    id: "kyl-cober",
    name: "Kyl Cober",
    location: "Stoke Climsland",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/91oh2wmf_Kyl%20Cober%20-%20Stoke%20Climsland.webp",
  },
  {
    id: "gratton-farm",
    name: "Gratton Farm",
    location: "Loddiswell",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/gmslita4_Gratton%20farm%20-%20Loddiswell%20.webp",
  },
  {
    id: "seaton-house",
    name: "Seaton House",
    location: "Looe",
    image: `${IMG}/t1IwiBHJmuO2GsAPH1UZgTPis.jpg?width=800`,
  },
  {
    id: "glenholt-close",
    name: "Glenholt Close",
    location: "Plymouth",
    image: `${IMG}/9J6lggBb5bJ1evFtmk2U3R1EiQ.jpg?width=800`,
  },
  {
    id: "park-farm",
    name: "Park Farm",
    location: "Teignmouth",
    image: `${IMG}/3h1LmYL7Q64xlf6IdWbWtHhqio.jpg?width=800`,
  },
  {
    id: "gras-lawn",
    name: "Gras Lawn",
    location: "Exeter",
    image: `${IMG}/1JQfAUKvtrwvAsKZR4C9bmWB1c.jpeg?width=800`,
  },
];

// Additional projects shown on the Projects page only (not the homepage preview)
export const extraProjects = [
  {
    id: "the-shippen",
    name: "The Shippen",
    location: "",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/sl7eujtr_The%20Shippen.webp",
  },
  {
    id: "pit-barn",
    name: "Pit Barn",
    location: "",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/2oprgf0s_Pit%20Barn.png",
  },
  {
    id: "hartstone-house",
    name: "Hartstone House",
    location: "",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/kue4rv8q_Hartstone%20House.webp",
  },
];

export const testimonials = [
  {
    id: "alistair-dewhirst",
    rating: 5,
    quote:
      "We are so pleased that we chose BASE Support to manage the alterations to our house in Kingsbridge. Their professionalism and help has been outstanding from the start.\n\nWe were grateful for their open cost tendering and willingness to help cost engineer items of the project; their expertise has been invaluable in progressing the works through to completion. Complete Electrical Services, BASE's specialist sub-contractor, showed the same willingness to operate in a very helpful manner.\n\nFinally, the team who managed the build, led by an outstanding Site Manager, have been very caring throughout the build — they always tried to be cognisant of our needs and requirements as homeowners living in a building site. We are sure a more considerate team of builders could not be found.",
    type: "Homeowner",
    name: "Alistair Dewhirst",
    location: "Kingsbridge",
  },
  {
    id: "mike-hayward",
    rating: 5,
    quote:
      "Project was to remove an old lean-to utility room and replace with a new build larger utility room on an existing old thatched cottage. Luke and his team engaged quickly and came up with suitable dates and project time-line. They were very helpful throughout with excellent communications. This was important since the project encountered many complications and problems, mostly weather and design related, and not of their making. Their own team were all excellent. Luke in particular was very helpful and thoughtful in problem solving and engaged really well with us throughout. We would be happy to recommend.",
    type: "Homeowner",
    name: "Mike Hayward",
    location: "",
  },
  {
    id: "phil",
    rating: 5,
    quote:
      "Base Construction completed a side extension and interior alterations on our home project. A detailed estimate and prompt variation updates meant we knew exactly where we stood financially. The Base team members working on the project were polite, friendly and did their utmost to reduce the disruption and mess, as we were living on site. Most importantly the lads were grafters even during some pretty horrific weather conditions. The subcontractors used all had an exceptionally high standard of professionalism and pride in their work. Luke and Sam both made regular site visits which made our project feel cared about. A build was always going to be quite a stressful time but Base were there every step of the way to ease the stress and we're so pleased with the finished result. We've already recommended Base numerous times and will continue to do so.",
    type: "Homeowner",
    name: "Phil",
    location: "",
  },
  {
    id: "eloise-hay",
    rating: 5,
    quote:
      "We, Amii Interiors, have had the pleasure of working alongside Base construction on a few projects recently. We were engaged by the client, at our most recently completed collaborative project in Cornwall, to play a role in the project management of the extension and partner with Base to ensure the design was carried out smoothly. Luke & Steve have been a delight to work with. Their professionalism, attention to detail, communication, and skill make working with them, as designers, an absolute dream! We can't wait for the next project — bring it on!",
    type: "Interior Designer",
    name: "Eloise Hay",
    location: "Amii Interiors, Cornwall",
  },
  {
    id: "matt-stear",
    rating: 5,
    quote:
      "Complete Electrical Contractors have worked with Base Construction for approximately 5 years on numerous projects, of all sizes. Their attention to detail is of the highest standard, due to having a well rounded team of tradesmen and management. Would highly recommend to anyone looking at having any construction work carried out, you won't be disappointed.",
    type: "Electrical Contractor",
    name: "Matt Stear",
    location: "Complete Electrical",
  },
  {
    id: "nick-baxendale",
    rating: 5,
    quote:
      "We have been working alongside Base now for numerous years on many stand out projects, providing them with the glazing. It couldn't be made more simple working on their projects due to how well organised they are, attention to detail and the brilliant relationship we have with their staff. We look forward to working with them in the future and we certainly wouldn't hesitate recommending them to any clients that require their services.",
    type: "Glazing Partner",
    name: "Nick Baxendale",
    location: "NB Installations (South West) Ltd",
  },
  {
    id: "stephen-marsh",
    rating: 5,
    quote:
      "My experience with Base has been extremely positive. My project has been the complete refurbishment of a 4 bedroom bungalow. This has included some building work to alter living spaces and creating a utility room and a shower room plus the usual new kitchen and bathroom. This isn't a large project for Base but they've always treated it like it's a large project. They're friendly and responsive at all times and the work is excellent quality. I have no hesitation in recommending Base and would be happy to speak to anyone who would like to know more.",
    type: "Homeowner",
    name: "Stephen Marsh",
    location: "",
  },
  {
    id: "nathaniel-morris",
    rating: 5,
    quote:
      "I've worked with Luke and the rest of the team at Base for over 5 years now on numerous projects and have always found their attentiveness and attention to detail on their projects to be fantastic. More importantly our clients are regularly commenting on their positive experiences with Luke and the rest of the team. They have developed some beautiful barn conversions and extensions for our clients over the years and hopefully will continue to do so for years to come!!",
    type: "Design Partner",
    name: "Nathaniel Morris",
    location: "",
  },
  {
    id: "neil-macdonald",
    rating: 5,
    quote:
      "Base supported us in a tender for a significant property renovation. Luke and his team were professional, responsive and knowledgeable. Communications were fantastic, and the team were open and transparent in their advice to us. They offered really helpful professional advice on adaptations we needed to make. Would highly recommend working with them.",
    type: "Client",
    name: "Neil Macdonald",
    location: "",
  },
  {
    id: "calum-finch",
    rating: 5,
    quote:
      "We've recently worked with Base on a high end renovation project and can highly recommend them. As with any property renovation, issues arise but any problems were taken seriously and plans made promptly to resolve them. They're a professional outfit and we're very pleased with the quality of the result.",
    type: "Homeowner",
    name: "Calum Finch",
    location: "",
  },
  {
    id: "sara-weyland",
    rating: 5,
    quote:
      "We have been working with Base Property Support over the past several months on what started out as a kitchen renovation and is now almost a full house renovation on a Grade II listed farmhouse near Totnes. Luke and his team have been exceptionally good at communicating, responding promptly to questions, translating 'builder speak' into something we can understand as first time home renovators, clearly explaining options without pressure and proactively sign posting whenever they spot something that might become an issue. They have been organised and transparent about the moving parts, including providing spreadsheets with cost estimates and project timelines. Luke and Sam have been excellent at project managing, all while staying approachable, good natured and easy to talk to. We have been impressed at the level of professionalism and workmanship and would unreservedly recommend them.",
    type: "Homeowner",
    name: "Sara Weyland",
    location: "Totnes",
  },
  {
    id: "isla-janjanin",
    rating: 5,
    quote:
      "We approached BASE to quote for our project and found them to be a highly professional company with excellent communication. They were thorough in understanding our needs and provided clear, detailed responses. Overall, we were impressed by their level of service and look forward to potentially working with them in the future.",
    type: "Client",
    name: "Isla Janjanin",
    location: "",
  },
  {
    id: "sophie-prideaux",
    rating: 5,
    quote:
      "Base Property Support visited my property to provide a quote for their services. They were right on time, very professional and provided ongoing support post-visit in relation to providing and explaining their quote. The work is not going ahead at this time but I would definitely recommend this team if you want to work with a company who show professionalism and honesty. Great people and company.",
    type: "Client",
    name: "Sophie Prideaux",
    location: "",
  },
  {
    id: "liz-garner",
    rating: 5,
    quote:
      "Amazing company with very helpful and supportive staff who were understanding of our requirements and gave us advice when we weren't sure about some issues. Highly recommend Luke and his team.",
    type: "Homeowner",
    name: "Liz Garner",
    location: "",
  },
];

export const heroImages = {
  home: `${IMG}/t1IwiBHJmuO2GsAPH1UZgTPis.jpg?width=1600`,
  contractor: `${IMG}/9J6lggBb5bJ1evFtmk2U3R1EiQ.jpg?width=1400`,
  projects: `${IMG}/1JQfAUKvtrwvAsKZR4C9bmWB1c.jpeg?width=1400`,
};

export const contact = {
  email: "info@base-support.co.uk",
  careers: "info@base-support.co.uk",
  phone: "01752 695 921",
  phoneRaw: "01752695921",
  address: "Base Construction, Unit 3, Devonshire Meadows, PL6 7EZ",
};

export const budgetOptions = [
  "Under £100,000",
  "£100,000 - £200,000",
  "£200,000 - £300,000",
  "£300,000 - £500,000",
  "£500,000 - £750,000",
  "£750,000 - £1,000,000",
  "£1,000,000 - £1,500,000",
  "£1,500,000 - £2,000,000",
  "£2,000,000 +",
];

export const brochureUrl = "https://heyzine.com/flip-book/2c65a84a7c.html";

export const teamIntro =
  "We are principal contractors specialising in one-off and bespoke build projects throughout Devon and Cornwall. Our own site teams carry out groundworks, masonry and carpentry works whilst our diverse management team coordinate approved specialist contractors and suppliers so that we can provide you with the full package on just about anything you can imagine for your project.";

export const teamStats = [
  { value: "50+", label: "Projects Delivered" },
  { value: "100+", label: "Years Combined Experience" },
  { value: "98%", label: "Client Satisfaction" },
];

export const teamHeroImage = `${IMG}/uBX8Pcgz4PzkwvIimRZvzmfgkac.jpeg?width=1400`;

export const teamMembers = [
  { name: "Luke Clement", role: "Co-owner / Managing Director", image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/sun0t36f_Luke.webp" },
  { name: "Sam Healeas", role: "Co-owner / Commercial Director", image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/f1l5diey_Sam%20H.webp" },
  { name: "Samantha Clement", role: "Co-owner / Admin Director", image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/h3adbhsv_Sam%20C.webp" },
  { name: "Kat Pitcher", role: "Office Manager", image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/023631268f5c0e26_Kat.webp" },
  { name: "Steve Fletcher", role: "Contracts Manager", image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/5cyw9szr_Steve.webp" },
  { name: "John", role: "Site Foreman", image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/425e0f73593b193b_John.webp" },
  { name: "Rob Slanley", role: "Site Foreman", image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/kwo901d0_Rob.webp" },
  { name: "Jacob Sampson", role: "Site Foreman", image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/lp6oempr_Jacob.webp" },
];

export const teamValues = [
  {
    title: "Transparency",
    body:
      "We prioritise clear and concise communication, ensuring that clients, staff, and project partners have full visibility and understanding throughout every stage of the process.",
    image: `${IMG}/0DS37TpVwTlHygKxM0Hdslr87I.jpg?width=800`,
  },
  {
    title: "Innovation",
    body:
      "We invest in training and development to provide our team with growth opportunities, ensuring we can deliver high-quality projects incorporating the latest building methods, design trends, and energy-efficient solutions.",
    image: `${IMG}/KoWgHGOnVVBH2F9jA0Im9NEz70.jpeg?width=800`,
  },
  {
    title: "Communication",
    body:
      "We believe in the power of shared success. By delivering high-quality projects on time and within budget, we ensure that everyone in the project team benefits — achieved through collaboration and working together towards a great outcome.",
    image: `${IMG}/bB2Kn0JX1GpMFk8Aiw7G6lENY.jpeg?width=800`,
  },
];

export const nav = [
  { label: "Services", to: "/#services" },
  { label: "Projects", to: "/projects" },
  { label: "Team", to: "/team" },
  { label: "Testimonials", to: "/testimonials" },
];
